export enum OrderItemState {
  STATE_NEW = 'new',
  STATE_PROCESSING_ERROR = 'processing_error',
  STATE_PROCESSED = 'processed',
  STATE_FULFILLED = 'fulfilled',
}

export const OrderItemFinalStates = [
  OrderItemState.STATE_FULFILLED,
  OrderItemState.STATE_PROCESSING_ERROR,
]
